'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('ifeis.nyi', ['ngMaterial']).factory('fNyiAlert', function ($mdDialog) {
  return function (event) {
    var nyiAlert = $mdDialog.alert().title('Not yet implemented.').textContent('The feature you are trying to access is not available, either because it is not ' + 'yet created or it has been temporarily disabled.').targetEvent(event).ok('Close');

    return $mdDialog.show(nyiAlert);
  };
});


//////////////////
// WEBPACK FOOTER
// ./nyi-alert/index.js
// module id = 211
// module chunks = 0